// extracted by mini-css-extract-plugin
module.exports = {"vanlife-menu-nav":"MenuNav_vanlife-menu-nav__r4Y2q"};